/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  HanaiBaseMock,
  HanaiBaseMockInterface,
} from "../../../contracts/mock/HanaiBaseMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "DuplicatedMint",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonLocker",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByLocker",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "isApprovedOrOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lockers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum HanaiBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "updateAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "locker",
        type: "address",
      },
      {
        internalType: "bool",
        name: "valid",
        type: "bool",
      },
    ],
    name: "updateLocker",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type HanaiBaseMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HanaiBaseMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HanaiBaseMock__factory extends ContractFactory {
  constructor(...args: HanaiBaseMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HanaiBaseMock> {
    return super.deploy(
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<HanaiBaseMock>;
  }
  override getDeployTransaction(
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(admin, royaltyAddress, overrides || {});
  }
  override attach(address: string): HanaiBaseMock {
    return super.attach(address) as HanaiBaseMock;
  }
  override connect(signer: Signer): HanaiBaseMock__factory {
    return super.connect(signer) as HanaiBaseMock__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HanaiBaseMockInterface {
    return new utils.Interface(_abi) as HanaiBaseMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HanaiBaseMock {
    return new Contract(address, _abi, signerOrProvider) as HanaiBaseMock;
  }
}
